<template>
    <div></div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'EditCardDetailsFormChargebee',
    props: {
        autoClose: {
            default: false,
            type: Boolean,
        },
    },
    data() {
        return {
            chargebeeInstance: null,
            previousStep: null,
        };
    },
    methods: {
        openCBPopup() {
            this.chargebeeInstance.openCheckout({
                hostedPage: () => {
                    return new Promise((resolve, reject) => {
                        resolve({ url: this.selfHostedUrl });
                    });
                },
                step: (step) => {
                    if (this.autoClose && this.previousStep === 'portal_assign_role_payment_method' && step === 'portal_payment_methods') {
                        this.chargebeeInstance.closeAll();
                        this.$emit('closed');
                    }

                    this.previousStep = step;
                },
                close: () => {
                    this.$emit('closed');
                },
            });
        },
        close() {
            this.$emit('closed');
        },
    },
    computed: {
        ...mapGetters({
            selfHostedUrl: 'account/getSelfHostedUrl',
        }),
    },
    mounted() {
        this.chargebeeInstance = Chargebee.init({
            site: process.env.VUE_APP_CHARGEBEE_ENVIRONMENT,
        });
        this.openCBPopup();
    },
};
</script>
